import { uid } from "@xbs/lib-state";
import moveRow from "./move";
export default function (store, ev) {
    const state = store.getState();
    const rows = state.rows;
    const id = ev.id || ev.row?.id || uid();
    const rowObj = {
        id,
        label: "Untitled",
        collapsed: false,
        ...(ev.row || {}),
    };
    rows.push(rowObj);
    if (!state.rowKey) {
        const rowKey = (state.rowKey = "rowKey");
        state.rows[0] = {
            id: "default",
            label: "Untitled",
        };
        state.cards.map(card => {
            card[rowKey] = "default";
        });
    }
    const { cardsMap, areasMeta } = store.getInnerState({
        ...state,
        rows,
    });
    store.setState({ rows, cardsMap, areasMeta, rowKey: state.rowKey });
    if (ev.before) {
        moveRow(store, { id, before: ev.before });
    }
    store.in.exec("scroll", {
        to: "row",
        id,
    });
    ev.id = id;
    ev.row = rowObj;
    return () => {
        store.in.exec("delete-row", { id, $meta: { skipHistory: true } });
    };
}
//# sourceMappingURL=add.js.map